const FindItems = (scope, target, action) => {
  if (scope.querySelectorAll(target).length < 1) {
    return;
  }

  let items = scope.querySelectorAll(target),
    i;

  for (i = 0; i < items.length; i++) {
    action(items[i]);
  }
};

export default FindItems;
